// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(min-width: 1024px)";
var _3 = "screen and (max-width: 600px)";
var _4 = "chip-WFf8j";
var _5 = "close-3ESyu";
export { _1 as "__esModule", _2 as "desktop_only", _3 as "mobile", _4 as "chip", _5 as "close" }
export default { "__esModule": _1, "desktop_only": _2, "mobile": _3, "chip": _4, "close": _5 }
